import { AvailableTicket, IFinalEvent } from "types/event"

export const getLowestTicketPrice = (event: IFinalEvent) => {
    // 1) Use lowest_price from API (v2 events and sections)
    if (
        typeof event?.lowest_price === "number" &&
        !Number.isNaN(event.lowest_price)
    ) {
        return event.lowest_price
    }

    // 2) Fallback to legacy price field (old sections payload)
    if (
        typeof event?.price === "number" &&
        !Number.isNaN(event.price)
    ) {
        return event.price
    }

    // 3) Fallback to availableTickets when neither field is provided (single event page)
    const tickets = event?.availableTickets as AvailableTicket[] | undefined

    if (!tickets || tickets.length === 0) {
        return 0
    }

    let lowestPrice = Number.POSITIVE_INFINITY

    for (const ticket of tickets) {
        if (!ticket) continue

        const hasDiscount =
            Boolean(ticket.discount) &&
            typeof ticket.discount.current_value === "number" &&
            ticket.discount.current_value > 0

        const rawPrice = hasDiscount
            ? ticket.discount.current_value
            : ticket.price

        const effectivePrice =
            typeof rawPrice === "number" ? rawPrice : Number(rawPrice)

        if (Number.isFinite(effectivePrice) && effectivePrice >= 0) {
            lowestPrice = Math.min(lowestPrice, effectivePrice)
        }
    }

    if (!Number.isFinite(lowestPrice) || lowestPrice < 0) {
        return 0
    }
    
    return lowestPrice
}

export const hasMultiplePrices = (event: IFinalEvent) => {
    // For list views with lowest_price, we don't have multiple prices info
    // Return false to show single price
    if (typeof event?.lowest_price === "number") {
        return false
    }

    if (event?.availableTickets && event?.availableTickets?.length > 1) {
        // check if all tickets have the same price
        const prices = event?.availableTickets?.map(
            (ticket: AvailableTicket) => ticket?.price
        ) as number[]

        return new Set(prices).size !== 1
    }

    return false
}
